import React from "react";
import hi from "../assets/intro.gif";

const Landing = () => {
  return (
    <section className="home" id="home">
      <div className="home-text">
        <h4>Hello,</h4>
        <h1>
          I'm Victor <br />
          Kinoti <br /> <span>Karemu</span>
        </h1>
        <h3>Software Engineer/Full-Stack Developer</h3>
        <a
          href="https://docs.google.com/document/d/1vYJ6hhvBEIia2g4uRII9V-Zi6fziLXT4KkJvg8uTQ_E/edit?usp=share_link"
          className="btn"
        >
          Download CV
        </a>
        <div className="about-text">
          <p>
            To Gain access to my cv please apply google drive access through the
            button above then send a message to me through the contact form to
            gain access A$AP.
          </p>
        </div>
      </div>
      <img className="hi" src={hi} alt="hi" width={510} height={510} />
    </section>
  );
};

export default Landing;
